export const SCROLLING_MODULE_CLASSNAME = 'scrolling-module';
export const SCROLLER_CLASSNAME = 'registered-scroller';

// Scroller IDs
export const DEFAULT = 'default';
export const CRUISE_DETAIL_MODAL = 'itinerary-panel';
export const FILTERS_MODAL = 'search-modal';
export const SIDE_BAR_MENU = 'MenuScroller';
